export default {
	'register': '/user/register', //注册
	'login': '/user/login', //登录
	'base_info': '/common/getConfig', //基本信息获取
	'user_info': '/user/getUserInfo', //用户信息获取
	'getData': '/index/getData', //首页
	'LotteryTypeList': '/lottery/getLotteryTypeList', //投票
	'LotteryList': '/lottery/getLotteryList', //投票数据
	'LotteryInfo': '/lottery/getLotteryInfo', //投票详情
	'lotterySubmit': '/lottery/lotterySubmit', //投票下注
	'beautyGetData': '/Beauty/getData', //获取美女数据
	'getBeautyList': '/beauty/getBeautyList', //获取美女列表
	'getBeautyInfo': '/beauty/getBeautyInfo', //获取美女详情
	'submit': '/beauty/submit', //预约美女
	'getType': '/film/getType', //电影分类
	'getFilmList': '/film/getFilmList', //全部电影
	'getFilmInfo': '/film/getFilmInfo', //电影详情
	'getBulletinList': '/richtext/getBulletinList', //通知
	'profile': '/user/profile', //修改人员信息
	'bankBind': '/user/bankBind', //绑定银行卡
	'resetpwd': '/user/resetpwd', //修改密码
	'withdrawSubmit': '/withdraw/submit', //提现
	'getWithdrawList': '/withdraw/getWithdrawList', //提现记录
	'getAccountList': '/user/getAccountList', //提现记录
	'getAccountInfo': '/user/getAccountInfo', //账户信息
	'getRechargeList': '/recharge/getRechargeList', //存款记录
	'getLotteryOrderHistory': '/lottery/getLotteryOrderHistory', //投注记录
	'getOrderData': '/order/getOrderData', //新投票
	'getUserOrderInfo': '/order/getUserOrderInfo', //新投票
	'createOrder': '/order/createOrder', //新投票
	'completeOrder': '/order/completeOrder', //新投票
	'getRechargeInfo': '/recharge/getRechargeInfo', //充值详情
	'getWithdrawInfo': '/withdraw/getWithdrawInfo', //提现详情
}